"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manuallyManagedGifCache = exports.volatileGifCache = void 0;
const index_1 = require("./lru/index");
exports.volatileGifCache = new index_1.QuickLRU({ maxSize: 30 });
exports.manuallyManagedGifCache = new Map();
